// extracted by mini-css-extract-plugin
var _1 = "ra-sticky-drawer";
var _2 = "ra-sticky-drawer-wrapper";
export { _1 as "stickyDrawerCls", _2 as "stickyDrawerWrapperCls" }
